export default {
  CONSUMER: "consumer",
  PARTNER: "partner"
};
